import { AxiosInstance, AxiosResponse } from 'axios';
import HttpClient from "./httpClient";
import { UserSettings } from "../interfaces/UserSettings";
import keycloak from '../config/keycloak';
import { User } from '../interfaces/User';

class UserSettingService {

  private baseUrl = process.env.REACT_APP_API_BASE_URL as string
  private axiosInstance: AxiosInstance;

  constructor() {
    this.axiosInstance = new HttpClient(this.baseUrl).getAxiosInstance();
  }



  async getUserSettings(): Promise<UserSettings> {
    try {
      const username = keycloak.tokenParsed?.preferred_username
      const endpoint = `/user-settings/${username}`;
      const response: AxiosResponse<UserSettings> = await this.axiosInstance.get(endpoint);
      return response.data;
    } catch (error: any) {
      console.debug("Error retrieving user settings:", error.response?.data || error.message);
      throw error;
    }
  }

  async updateUserSettings(settings: UserSettings, id: number): Promise<void> {
    try {
      const endpoint = `/user-settings/${id}`;
      await this.axiosInstance.put(endpoint, settings);
    } catch (error: any) {
      console.debug("Error creating Usersettings:", error.response?.data || error.message);
      throw error;
    }
  }

  async createUserSettings(farm: UserSettings): Promise<UserSettings> {
    try {
      const endpoint = "/user-settings";
      const response =  await this.axiosInstance.post(endpoint, farm);
      return response.data;
    } catch (error: any) {
      console.debug("Error creating farm:", error.response?.data || error.message);
      throw error;
    }
  }

  async registerUser(): Promise<void> {
    try {
      const endpoint = "/user-management/register";
      await this.axiosInstance.post(endpoint);
      return;
    } catch (error: any) {
      console.debug("Error register user", error.response?.data || error.message);
      throw error;
    }
  }

  async getUser(): Promise<User> {
    try {
      const endpoint = "/user-management/user";
      return (await this.axiosInstance.get(endpoint)).data;
    } catch (error: any) {
      console.debug("Error register user", error.response?.data || error.message);
      throw error;
    }
  }

 
}

export default UserSettingService;